import styles from "./Button.module.css";
import { memo } from "react"

const Button = ({ text }) => {
    return <button className={styles.button}>{text}</button>;
};

export default memo(Button);
